import { jsx as _jsx } from "react/jsx-runtime";
import * as CarIcons from '../../atoms/special/carIcons';
export var MappedVehicleTypes = function (type) {
    switch (type) {
        case 'CONVERTIBLE':
        case 'CON':
            return _jsx(CarIcons.Convertible, {});
        case 'COUPE':
        case 'COU':
            return _jsx(CarIcons.Coupe, {});
        case 'ESTATE':
        case 'E':
            return _jsx(CarIcons.Estate, {});
        case 'LIGHT 4x4 UTILITY':
        case 'L4U':
            return _jsx(CarIcons.FourByFour, {});
        case '5 DOOR HATCHBACK':
        case 'H':
            return _jsx(CarIcons.HatchbackFiveDoor, {});
        case '4 DOOR SALOON':
        case 'S':
        case '4DS':
            return _jsx(CarIcons.SaloonFourDoor, {});
        case '2 DOOR SALOON':
        case '2DS':
            return _jsx(CarIcons.SaloonTwoDoor, {});
        case 'SPORTS':
        case 'SP':
            return _jsx(CarIcons.Sports, {});
        case 'VAN - SIDE WINDOWS':
        case 'VSW':
            return _jsx(CarIcons.VanSideWindows, {});
        default:
            return _jsx(CarIcons.HatchbackThreeDoor, {});
    }
};
